module.exports = {"410185001":"嵩阳街道","410185002":"少林街道","410185003":"中岳街道","410185100":"大金店镇","410185101":"颖阳镇","410185102":"卢店镇","410185103":"告成镇","410185104":"阳城区镇","410185105":"大冶镇","410185106":"宣化镇","410185107":"徐庄镇","410185108":"东华镇","410185202":"白坪乡","410185203":"君召乡","410185204":"石道乡","410185205":"唐庄乡","410185400":"送表矿区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410185.json
// module id = 1400
// module chunks = 0